'use client';

import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '../../../shared/cn';
export function Label4(t0) {
  const $ = _c(10);
  let className;
  let htmlFor;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      htmlFor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = htmlFor;
    $[3] = props;
  } else {
    className = $[1];
    htmlFor = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("font-medium text-contentPrimary", "text-xs", "flex select-none items-center gap-2 font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== htmlFor || $[7] !== props || $[8] !== t1) {
    t2 = <label data-slot="label" htmlFor={htmlFor} className={t1} {...props} />;
    $[6] = htmlFor;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}